import React from 'react';

import { useReshipContext } from './reship-context-provider';
import { Button } from 'ui-components/components/button';
import { FormattedMessage } from 'react-intl';
import { messages } from './messages';

export const ReshipButton = () => {
  const { reship, canReship } = useReshipContext();

  if (!canReship) {
    return null;
  }

  return (
    <Button onClick={reship} theme='primary'>
      <FormattedMessage {...messages.reshipButton} />
    </Button>
  );
};
